import { component } from "picoapp";


export default component((node) => {
    const prelovedbtns = node.querySelectorAll(".product-condition--metafield");
    console.log(prelovedbtns, 'fail')
  
  
    const revealText = (productCondtion) => {
      var i, tabcontent, tablinks;
      tabcontent = node.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }
      tablinks = node.getElementsByClassName("product-condition--metafield");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" show", "");
      }
      document.getElementById(productCondtion).style.display = "block";
    }

    const hideText = (productCondtion) =>{
      document.getElementById(productCondtion).style.display = "none";
      document.querySelector(".show").style.display = "block";
    }
  
    prelovedbtns[0].addEventListener("mouseover", () => revealText('ok'));
    prelovedbtns[1].addEventListener("mouseover", () => revealText('fin'));
    prelovedbtns[2].addEventListener("mouseover", () => revealText('som_ny'));
    prelovedbtns[0].addEventListener("mouseout", () => hideText('ok'));
    prelovedbtns[1].addEventListener("mouseout", () =>  hideText('fin'));
    prelovedbtns[2].addEventListener("mouseout", () => hideText('som_ny'));
})